// modifer: styles/jss/nextjs-material-kit-pro/pages/profilePageStyle
import { cardTitle, coloredShadow, boxShadow } from 'styles/jss/original/base';

import imagesStyle from 'styles/jss/nextjs-material-kit-pro/imagesStyles.js';

const styles = {
  coloredShadow,
  ...imagesStyle,
  card: {
    textAlign: 'left !important',
    border: '1px solid #e0e0e0',
    marginTop: '20px',
    marginBottom: '20px',
    ...boxShadow
  },
  cardTitle: {
    ...cardTitle,
    fontSize: '0.875rem'
  },
  cardBody: {
    textAlign: 'center',
    marginLeft: '-35px',
    '@media (max-width: 768px)': {
      marginLeft: '0px'
    }
  },
  alignCenter: {
    alignItems: 'center'
  }
};

export default styles;
